import * as React from 'react';

function SvgTumblrMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.745 25.91c-3.295 0-5.75-1.696-5.75-5.752v-6.495H9v-3.516C12.295 9.29 13.673 6.456 13.832 4h3.422v5.576h3.992v4.087h-3.992v5.656c0 1.695.855 2.281 2.217 2.281h1.933v4.31h-3.659z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgTumblrMono;
